import React, { useState, useEffect } from "react";
import axios from 'axios';
import { BaseUrl } from "../App";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const PaymentSettings = () => {
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [methods, setMethods] = useState([
    {
      name: "Pay Locally",
      dbKey: "ct_pay_locally_status",
      toggles: [],
      enabled: false,
    },
    {
      name: "Paypal Express Checkout",
      dbKey: "ct_paypal_express_checkout_status",
      fields: [
        { label: "API Username", type: "text", value: "", dbKey: "ct_paypal_api_username" },
        { label: "API Password", type: "password", value: "", dbKey: "ct_paypal_api_password" },
        { label: "Signature", type: "text", value: "", dbKey: "ct_paypal_api_signature" },
      ],
      toggles: [
        { label: "Paypal guest payment", enabled: false, dbKey: "ct_paypal_guest_payment_status" },
        { label: "Test Mode", enabled: false, dbKey: "ct_paypal_test_mode_status" },
      ],
      enabled: false,
    },
    {
      name: "Authorize.Net Payment Form",
      dbKey: "ct_authorizenet_status",
      fields: [
        { label: "API Login ID", type: "text", value: "", dbKey: "ct_authorizenet_API_login_ID" },
        { label: "Transaction Key", type: "password", value: "", dbKey: "ct_authorizenet_transaction_key" },
      ],
      toggles: [
        { label: "Sandbox Mode", enabled: false, dbKey: "ct_authorize_sandbox_mode" }
      ],
      enabled: false,
    },
    {
      name: "Stripe Payment Form",
      dbKey: "ct_stripe_payment_form_status",
      fields: [
        { label: "Publishable Key", type: "text", value: "", dbKey: "ct_stripe_publishablekey" },
        { label: "Secret Key", type: "password", value: "", dbKey: "ct_stripe_secretkey" },
      ],
      toggles: [],
      enabled: false,
    },
    {
      name: "2Checkout Payment Form",
      dbKey: "ct_2checkout_status",
      fields: [
        { label: "Publishable Key", type: "text", value: "", dbKey: "ct_2checkout_publishkey" },
        { label: "Private Key", type: "password", value: "", dbKey: "ct_2checkout_privatekey" },
        { label: "Seller ID", type: "text", value: "", dbKey: "ct_2checkout_sellerid" },
      ],
      toggles: [
        { label: "Test Mode", enabled: false, dbKey: "ct_2checkout_sandbox_mode" }
      ],
      enabled: false,
    },
    {
      name: "Bank Transfer",
      dbKey: "ct_bank_transfer_status",
      fields: [
        { label: "Bank Name", type: "text", value: "", dbKey: "ct_bank_name" },
        { label: "Account Name", type: "text", value: "", dbKey: "ct_account_name" },
        { label: "Account Number", type: "text", value: "", dbKey: "ct_account_number" },
        { label: "Branch Code", type: "text", value: "", dbKey: "ct_branch_code" },
        { label: "IFSC Code", type: "text", value: "", dbKey: "ct_ifsc_code" },
        { label: "Bank Description", type: "text", value: "", dbKey: "ct_bank_description" },
      ],
      toggles: [],
      enabled: false,
    },
  ]);

  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  const fetchSettings = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: 'get_all_settings',
        api_key: 1
      });

      if (response.data.status === 'true' && response.data.statuscode === 200) {
        const settings = response.data.response;
        
        setMethods(prevMethods => {
          return prevMethods.map(method => {
            const methodStatus = settings.find(setting => 
              setting.option_name === method.dbKey
            )?.option_value === 'Y';

            const updatedFields = method.fields?.map(field => ({
              ...field,
              value: settings.find(setting => 
                setting.option_name === field.dbKey
              )?.option_value || ''
            }));

            const updatedToggles = method.toggles?.map(toggle => ({
              ...toggle,
              enabled: settings.find(setting => 
                setting.option_name === toggle.dbKey
              )?.option_value === 'Y'
            }));

            return {
              ...method,
              enabled: methodStatus,
              fields: updatedFields,
              toggles: updatedToggles
            };
          });
        });

       
      } else {
        throw new Error(response.data.response || 'Failed to fetch settings');
      }
    } catch (error) {
      setError('Error fetching settings: ' + (error.message || 'Unknown error'));
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const updateSetting = async (optionName, optionValue) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: 'update_setting',
        api_key: 1,
        option_name: optionName,
        option_value: optionValue
      });

      if (response.data.status !== 'true') {
        setSuccessMessage("Update Payment Setting Successfully!")

        throw new Error(response.data.response || 'Update failed');
      }
    } catch (error) {
      throw error;
    }
  };

  const toggleMethod = async (index) => {
    try {
      const enabledMethods = methods.filter(method => method.enabled).length;
      const method = methods[index];
      
      if (enabledMethods === 1 && method.enabled) {
        alert("Failed! At least one payment method should be enabled.");
        return;
      }

      const newEnabled = !method.enabled;
      await updateSetting(method.dbKey, newEnabled ? 'Y' : 'N');

      setMethods(prev =>
        prev.map((method, i) =>
          i === index ? { ...method, enabled: newEnabled } : method
        )
      );
    } catch (error) {
      setError('Error updating payment method status');
    }finally {
      setLoading(false);
    }
  };

  const handleFieldChange = (methodIndex, fieldIndex, newValue) => {
    setMethods(prev =>
      prev.map((method, i) =>
        i === methodIndex
          ? {
              ...method,
              fields: method.fields.map((field, j) =>
                j === fieldIndex ? { ...field, value: newValue } : field
              ),
            }
          : method
      )
    );
  };

  const toggleOption = async (methodIndex, toggleIndex) => {
    try {
      const method = methods[methodIndex];
      const toggle = method.toggles[toggleIndex];
      const newEnabled = !toggle.enabled;
      
      await updateSetting(toggle.dbKey, newEnabled ? 'Y' : 'N');
      
      setMethods(prev =>
        prev.map((method, i) =>
          i === methodIndex
            ? {
                ...method,
                toggles: method.toggles.map((toggle, j) =>
                  j === toggleIndex ? { ...toggle, enabled: newEnabled } : toggle
                ),
              }
            : method
        )
      );
    } catch (error) {
      setError('Error updating toggle status');
    }
  };

  const saveSettings = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage('');

    try {
      const promises = methods.flatMap(method => {
        const updates = [];
        
        if (method.fields) {
          updates.push(...method.fields.map(field => 
            updateSetting(field.dbKey, field.value)
          ));
        }
        
        return updates;
      });

      await Promise.all(promises);
      setSuccessMessage('Settings saved successfully!');
      await fetchSettings();
    } catch (error) {
      setError('Error saving settings: ' + (error.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  // if (loading) {
  //   return <div className="text-center py-6">Loading settings...</div>;
  // }

      return (
        <div className="relative min-h-screen">
        {/* Loading Indicator */}
          {loading && (
               <div className="fixed inset-0 flex items-center justify-center z-50">
                 <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
                   <FadeLoader 
                     height={15}
                     width={5}
                     color="#ffffff"
                     ariaLabel="loading"
                   />
                   <h1 className="mt-1 text-lg text-white">Please wait...</h1>
                 </div>
               </div>
             )}
             
            <div className="mx-auto p-6 bg-white shadow-md rounded-md xl:px-72">
          <div className="flex justify-between items-center mb-5">
          <h1 className="text-lg font-semibold">Payment Settings</h1>
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            onClick={saveSettings}
          >
            Save Settings
          </button>
        </div>
          {successMessage && (
                  <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
                    <span className="block sm:inline">{successMessage}</span>
                  </div>
                )}

                {error && (
                  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
                    <span className="block sm:inline">{error}</span>
                  </div>
                )}
      <div className="space-y-6">
        {methods.map((method, methodIndex) => (
          <div
            key={methodIndex}
            className="border bg-white-100 rounded-md p-4 shadow-sm transition-all duration-300 ease-in-out"
          >
            <div className="flex justify-between items-center">
              <h2 className="font-medium text-lg">{method.name}</h2>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={method.enabled}
                  onChange={() => toggleMethod(methodIndex)}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:bg-green-500 relative">
                  <span
                    className={`absolute w-4 h-4 bg-white rounded-full top-1 left-1 transition-transform ${
                      method.enabled ? "translate-x-5" : ""
                    }`}
                  ></span>
                </div>
              </label>
            </div>

            <div
              className={`overflow-hidden transition-all mt-10 duration-1000 ease-in-out`}
              style={{
                height: method.enabled ? "auto" : "0",
                opacity: method.enabled ? "1" : "0",
                paddingTop: method.enabled ? "10px" : "0",
                paddingBottom: method.enabled ? "10px" : "0",
              }}
            >
              {method.enabled &&
                method.fields &&
                method.fields.map((field, fieldIndex) => (
                  <div key={fieldIndex} className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">
                      {field.label}
                    </label>
                    <input
                      type={field.type}
                      value={field.value}
                      onChange={(e) => 
                        handleFieldChange(methodIndex, fieldIndex, e.target.value)
                      }
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                ))}

              {method.enabled &&
                method.toggles &&
                method.toggles.map((toggle, toggleIndex) => (
                  <div key={toggleIndex} className="flex items-center mt-4">
                    <label
                      className="text-sm font-medium text-gray-700 flex-grow"
                    >
                      {toggle.label}
                    </label>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={toggle.enabled}
                        onChange={() => toggleOption(methodIndex, toggleIndex)}
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:bg-green-500 relative">
                        <span
                          className={`absolute w-4 h-4 bg-white rounded-full top-1 left-1 transition-transform ${
                            toggle.enabled ? "translate-x-5" : ""
                          }`}
                        ></span>
                      </div>
                    </label>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>

      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-6"
        onClick={saveSettings}
      >
        Save Settings
      </button>
    </div>
 
  </div>
  );
};

export default PaymentSettings;
